import "./topbar.scss";
import { AccountBox, Mail, LinkedIn, GitHub, Assignment } from "@material-ui/icons";

export default function Topbar({ menuOpen, setMenuOpen }) {
  return (
    <div className={"topbar " + (menuOpen && "active")}>
      <div className="wrapper">
        <div className="left">
          <a href="#intro" className="logo">
            <img src="assets/xuan.png" alt="" />
          </a>
          <div className="itemContainer">
            <AccountBox className="icon" />
            <span>(530)220-0160</span>
          </div>
          <div className="itemContainer">
            <Mail className="icon" />
            <a href="mailto:dx474460783@gmail.com">dx474460783@gmail.com</a>
          </div>
          <div className="itemContainer">
            <LinkedIn className="icon" />
            <a href="https://www.linkedin.com/in/deng-xuan/">deng-xuan</a>
          </div>
          <div className="itemContainer">
            <GitHub className="icon" />
            <a href="https://github.com/Xuan-Deng">Xuan-Deng</a>
          </div>
          <div className="itemContainer">
            <Assignment className="icon" />
            <a href = "assets/XuanDengResume.pdf" target = "_blank">Resume</a>
          </div>
        </div>
        <div className="right">
          <div className="hamburger" onClick={()=>setMenuOpen(!menuOpen)}>
            <span className="line1"></span>
            <span className="line2"></span>
            <span className="line3"></span>
          </div>
        </div>
      </div>
    </div>
  );
}
